/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {


    import Timer = NodeJS.Timer;

    class CheckInSuccessController {
        public static $inject = [
            '$state',
            'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskLogic',
            'meevo.AppSettings',
            '$scope'
        ];

        checkinResultMessage: string;
        seconds: number;
        resetTimer: Timer;

        constructor(protected $state: ng.ui.IStateService,
                    protected selfCheckInKioskLogic: SelfCheckInKioskLogic,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected $scope: ng.IScope) {
            this.seconds = this.selfCheckInKioskLogic.kioskSettings.messageTimeout;
            this.checkinResultMessage = this.selfCheckInKioskLogic.kioskSettings.notSubmittedFormsPreventCheckinMessage;

            this.resetTimer = setInterval(() => {

                this.$scope.$apply(() => {
                    this.seconds--;

                    if (this.seconds <= 0) {

                        this.reset();
                        clearInterval(this.resetTimer);
                    }
                });
            }, 1000);
        }

        reset() {
            this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.login`);
            this.selfCheckInKioskLogic.reset();
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .controller('meevo.plugins.selfCheckInKiosk.CheckInFailController', CheckInSuccessController);
}
